/* globals videojs */
'use strict';

var dataLayer = window.dataLayer;

module.exports = {
    videoInteractions: function () {
        var videoArr = [];
        $('.tkovr-bottom .video-container .video-card').each(function () {
            var bannerId = $(this).data('ci-tracking');
            var bannerName = $(this).data('campaign-name');
            var position = $(this).data('position');
            var promoId = $(this).parents('.takeover-component').find('.tkovr-top .amplience-card a').data('ci-tracking');
            videoArr.push({
                name: bannerId,
                title: bannerName,
                position: position,
                promoId: promoId
            });
        });
        var obj = {
            event: 'Homepage Video Interaction',
            eventDetails: {
                eventAction: 'click',
                eventLabel: ''
            },
            video: videoArr[0]
        };
        var makeDuplicate = function (dataObj) {
            return JSON.parse(JSON.stringify(dataObj));
        };
        // Video Interactions Pause
        $(document).on('click', '#myPlayerID button.vjs-playing', function () {
            var newObj = makeDuplicate(obj);
            newObj.eventDetails.eventLabel = 'Pause';
            dataLayer.push(newObj);
        });
        // Video Interactions Play
        $(document).on('click', '#myPlayerID button.vjs-paused', function () {
            var newObj1 = makeDuplicate(obj);
            newObj1.eventDetails.eventLabel = 'Play';
            dataLayer.push(newObj1);
        });
        // Video Interactions Share
        $(document).on('click', '#myPlayerID button.vjs-share-control', function () {
            var newObj2 = makeDuplicate(obj);
            newObj2.eventDetails.eventLabel = 'Share';
            dataLayer.push(newObj2);
        });
    },
    videoPlayer: function () {
        if (typeof videojs !== 'undefined' && videojs.getPlayer('myPlayerID')) {
            videojs.getPlayer('myPlayerID').ready(function () {
                var myPlayer = this;
                var watched25Sent = false;
                var watched50Sent = false;
                var watched75Sent = false;
                var watched100Sent = false;
                var videoinfo = $('.tkovr-bottom .video-container .video-card');
                var promoinfo = videoinfo.parents('.takeover-component').find('.tkovr-top .amplience-card a').data('ci-tracking');
                myPlayer.on('loadstart', function () {
                    watched25Sent = false;
                    watched50Sent = false;
                    watched75Sent = false;
                    watched100Sent = false;
                });
                myPlayer.on('timeupdate', function () {
                    var mediainfo = {
                        name: videoinfo.data('ci-tracking'),
                        title: videoinfo.data('campaign-name'),
                        position: videoinfo.data('position'),
                        promoId: promoinfo
                    };
                    var eventName = 'Homepage Video Interaction';
                    var watchedPersent = myPlayer.cache_.currentTime * 100 / myPlayer.cache_.duration; // eslint-disable-line
                    if (!watched25Sent && watchedPersent > 25 && watchedPersent < 50) {
                        watched25Sent = true;
                        $('body').trigger('video:watched25Percent', { mediainfo, eventName });
                    }
                    if (!watched50Sent && watchedPersent > 50 && watchedPersent < 75) {
                        watched50Sent = true;
                        $('body').trigger('video:watched50Percent', { mediainfo, eventName });
                    }
                    if (!watched75Sent && watchedPersent > 75 && watchedPersent < 100) {
                        watched75Sent = true;
                        $('body').trigger('video:watched75Percent', { mediainfo, eventName });
                    }
                    if (!watched100Sent && watchedPersent > 99) {
                        watched100Sent = true;
                        $('body').trigger('video:watched100Percent', { mediainfo, eventName });
                    }
                });
            });
        }
    }
};
